import { render, staticRenderFns } from "./KurumAdi.vue?vue&type=template&id=1724f771&scoped=true"
import script from "./KurumAdi.vue?vue&type=script&lang=ts"
export * from "./KurumAdi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1724f771",
  null
  
)

export default component.exports